import { useEffect } from "react";

/** Mouse-parallax that writes --tx/--ty CSS vars on the shape element. */
export function useParallax(wrapRef, shapeRef, strength = 14) {
  useEffect(() => {
    const wrap = wrapRef.current;
    const shape = shapeRef.current;
    if (!wrap || !shape) return;
    let raf = null;
    const onMove = (e) => {
      const rect = wrap.getBoundingClientRect();
      const x = (e.clientX - rect.left) / rect.width - 0.5;
      const y = (e.clientY - rect.top) / rect.height - 0.5;
      if (raf) cancelAnimationFrame(raf);
      raf = requestAnimationFrame(() => {
        shape.style.setProperty("--tx", `${x * strength}px`);
        shape.style.setProperty("--ty", `${y * strength}px`);
      });
    };
    const onLeave = () => {
      if (raf) cancelAnimationFrame(raf);
      shape.style.setProperty("--tx", "0px");
      shape.style.setProperty("--ty", "0px");
    };
    wrap.addEventListener("mousemove", onMove);
    wrap.addEventListener("mouseleave", onLeave);
    return () => {
      wrap.removeEventListener("mousemove", onMove);
      wrap.removeEventListener("mouseleave", onLeave);
      if (raf) cancelAnimationFrame(raf);
    };
  }, [wrapRef, shapeRef, strength]);
}
